(() => {
  const scriptElement = document.currentScript;
  const root = scriptElement.closest('.complementary-products-dan');

  if (!root || root.dataset.complementaryAtcInitialized === 'true') {
    return;
  }

  root.dataset.complementaryAtcInitialized = 'true';

  const cards = Array.from(
    root.querySelectorAll('.complementary-product-card')
  );
  const cardState = new WeakMap();

  const getCardState = (card) => {
    if (cardState.has(card)) {
      return cardState.get(card);
    }

    const variantDataElement = card.querySelector(
      '[data-complementary-variants]'
    );
    let variants = [];

    if (variantDataElement) {
      try {
        variants = JSON.parse(variantDataElement.textContent);
      } catch (error) {
        console.error(
          'Could not parse complementary product variants.',
          error
        );
      }
    }

    const optionGroups = Array.from(
      card.querySelectorAll(
        '.complementary-product-card__option-group'
      )
    );

    const state = {
      variants,
      selectedOptions: Array(optionGroups.length).fill(null),
      optionGroups
    };

    cardState.set(card, state);
    return state;
  };

  const getCartAddUrl = () => {
    const rootPath =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return `${rootPath.replace(/\/?$/, '/')}cart/add.js`;
  };

  const setButtonLabel = (button, label) => {
    if (!button) {
      return;
    }

    if (!button.dataset.defaultLabel) {
      button.dataset.defaultLabel = button.textContent.trim();
    }

    button.textContent = label;
  };

  const restoreButtonLabel = (button) => {
    if (!button || !button.dataset.defaultLabel) {
      return;
    }

    button.textContent = button.dataset.defaultLabel;
  };

  const closeSheet = (card) => {
    const overlay = card.querySelector(
      '[data-complementary-variant-overlay]'
    );
    const openButton = card.querySelector(
      '[data-complementary-action="open-variants"]'
    );

    if (!overlay) {
      return;
    }

    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    card.classList.remove('is-variant-sheet-open');

    if (openButton) {
      openButton.setAttribute('aria-expanded', 'false');
    }
  };

  const closeOtherSheets = (currentCard) => {
    cards.forEach((card) => {
      if (card !== currentCard) {
        closeSheet(card);
      }
    });
  };

  const resetVariantSelection = (card) => {
    const state = getCardState(card);
    state.selectedOptions.fill(null);

    state.optionGroups.forEach((group) => {
      group
        .querySelectorAll(
          '[data-complementary-option-value]'
        )
        .forEach((pill) => {
          pill.classList.remove('is-selected');
          pill.setAttribute('aria-pressed', 'false');
        });
    });

    const errorElement = card.querySelector(
      '[data-complementary-variant-error]'
    );

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }
  };

  const variantMatchesSelections = (
    variant,
    selections,
    ignoredIndex = -1
  ) =>
    selections.every((selectedValue, index) => {
      if (index === ignoredIndex || selectedValue === null) {
        return true;
      }

      return variant.options[index] === selectedValue;
    });

  const getSelectedVariant = (state) => {
    if (
      state.selectedOptions.length === 0 ||
      state.selectedOptions.some((value) => value === null)
    ) {
      return null;
    }

    return (
      state.variants.find(
        (variant) =>
          variant.available &&
          variant.options.every(
            (value, index) =>
              value === state.selectedOptions[index]
          )
      ) || null
    );
  };

  const updateVariantAvailability = (card) => {
    const state = getCardState(card);

    state.optionGroups.forEach((group) => {
      const optionIndex = Number(group.dataset.optionIndex);

      group
        .querySelectorAll(
          '[data-complementary-option-value]'
        )
        .forEach((pill) => {
          const candidateValue =
            pill.dataset.complementaryOptionValue;

          const isPossible = state.variants.some(
            (variant) =>
              variant.available &&
              variant.options[optionIndex] === candidateValue &&
              variantMatchesSelections(
                variant,
                state.selectedOptions,
                optionIndex
              )
          );

          pill.disabled = !isPossible;
        });
    });

    const addButton = card.querySelector(
      '[data-complementary-action="add-selected"]'
    );

    if (!addButton) {
      return;
    }

    const selectedVariant = getSelectedVariant(state);

    if (selectedVariant) {
      addButton.disabled = false;
      addButton.dataset.variantId = String(selectedVariant.id);
      addButton.textContent = 'Agregar al carrito';
    } else {
      addButton.disabled = true;
      delete addButton.dataset.variantId;
      addButton.textContent = 'SELECCIONAR TALLA';
    }
  };

  const openSheet = (card) => {
    const overlay = card.querySelector(
      '[data-complementary-variant-overlay]'
    );
    const openButton = card.querySelector(
      '[data-complementary-action="open-variants"]'
    );

    if (!overlay) {
      return;
    }

    closeOtherSheets(card);
    resetVariantSelection(card);
    updateVariantAvailability(card);

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    card.classList.add('is-variant-sheet-open');

    if (openButton) {
      openButton.setAttribute('aria-expanded', 'true');
    }

    const firstEnabledPill = overlay.querySelector(
      '[data-complementary-option-value]:not(:disabled)'
    );

    if (firstEnabledPill) {
      window.setTimeout(() => firstEnabledPill.focus(), 250);
    }
  };

  const showError = (card, message) => {
    const errorElement = card.querySelector(
      '[data-complementary-variant-error]'
    );

    if (errorElement) {
      errorElement.textContent = message;
      errorElement.hidden = false;
    }
  };

  const flashSuccess = (card) => {
    const mainButton = card.querySelector(
      '[data-complementary-action="add-direct"], ' +
        '[data-complementary-action="open-variants"]'
    );

    if (!mainButton) {
      return;
    }

    setButtonLabel(mainButton, 'AGREGADO ✓');
    mainButton.disabled = true;

    window.setTimeout(() => {
      restoreButtonLabel(mainButton);
      mainButton.disabled = false;
    }, 1800);
  };

  const addVariantToCart = async (
    card,
    variantId,
    actionButton
  ) => {
    if (
      !variantId ||
      card.dataset.complementaryAtcLoading === 'true'
    ) {
      return;
    }

    card.dataset.complementaryAtcLoading = 'true';

    if (actionButton) {
      setButtonLabel(actionButton, 'AGREGANDO...');
      actionButton.disabled = true;
      actionButton.classList.add('is-loading');
    }

    try {
      const response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      const responseData = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            'No se pudo agregar el producto.'
        );
      }

      closeSheet(card);
      flashSuccess(card);

      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', {
          bubbles: true,
          cancelable: false
        })
      );

      document.dispatchEvent(
        new CustomEvent('complementary-product:added', {
          detail: {
            productId: card.dataset.productId,
            variantId: Number(variantId),
            response: responseData
          }
        })
      );
    } catch (error) {
      const message =
        error && error.message
          ? error.message
          : 'No se pudo agregar el producto.';

      if (
        actionButton &&
        actionButton.dataset.complementaryAction === 'add-direct'
      ) {
        setButtonLabel(actionButton, 'INTENTA DE NUEVO');

        window.setTimeout(() => {
          restoreButtonLabel(actionButton);
        }, 1800);
      } else {
        showError(card, message);
      }
    } finally {
      card.dataset.complementaryAtcLoading = 'false';

      if (actionButton) {
        actionButton.classList.remove('is-loading');

        if (
          actionButton.dataset.complementaryAction ===
          'add-selected'
        ) {
          const state = getCardState(card);
          const selectedVariant = getSelectedVariant(state);
          actionButton.disabled = !selectedVariant;

          if (selectedVariant) {
            actionButton.textContent = 'Agregar al carrito';
          }
        } else if (
          actionButton.textContent.trim() !== 'AGREGADO ✓'
        ) {
          actionButton.disabled = false;
        }
      }
    }
  };

  root.addEventListener('click', (event) => {
    const actionElement = event.target.closest(
      '[data-complementary-action]'
    );

    if (!actionElement || !root.contains(actionElement)) {
      return;
    }

    const card = actionElement.closest(
      '.complementary-product-card'
    );

    if (!card) {
      return;
    }

    const action = actionElement.dataset.complementaryAction;

    if (action === 'open-variants') {
      openSheet(card);
      return;
    }

    if (action === 'close-variants') {
      closeSheet(card);
      return;
    }

    if (action === 'add-direct') {
      addVariantToCart(
        card,
        actionElement.dataset.variantId,
        actionElement
      );
      return;
    }

    if (action === 'add-selected') {
      addVariantToCart(
        card,
        actionElement.dataset.variantId,
        actionElement
      );
    }
  });

  root.addEventListener('click', (event) => {
    const pill = event.target.closest(
      '[data-complementary-option-value]'
    );

    if (!pill || !root.contains(pill) || pill.disabled) {
      return;
    }

    const card = pill.closest('.complementary-product-card');
    const group = pill.closest(
      '.complementary-product-card__option-group'
    );

    if (!card || !group) {
      return;
    }

    const state = getCardState(card);
    const optionIndex = Number(group.dataset.optionIndex);
    const optionValue = pill.dataset.complementaryOptionValue;

    state.selectedOptions[optionIndex] = optionValue;

    group
      .querySelectorAll('[data-complementary-option-value]')
      .forEach((groupPill) => {
        const isSelected = groupPill === pill;
        groupPill.classList.toggle(
          'is-selected',
          isSelected
        );
        groupPill.setAttribute(
          'aria-pressed',
          String(isSelected)
        );
      });

    const errorElement = card.querySelector(
      '[data-complementary-variant-error]'
    );

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }

    updateVariantAvailability(card);
  });

  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    const openOverlay = root.querySelector(
      '[data-complementary-variant-overlay].is-open'
    );

    if (!openOverlay) {
      return;
    }

    const card = openOverlay.closest(
      '.complementary-product-card'
    );

    if (card) {
      closeSheet(card);

      const openButton = card.querySelector(
        '[data-complementary-action="open-variants"]'
      );

      if (openButton) {
        openButton.focus();
      }
    }
  });
})();
